<template>
  <div class="poi h-full w-full flex flex-col relative" v-if="poi">
    <div class="relative max-h-420">
      <img v-if="getBackgroundUrl" :src="getBackgroundUrl" class="w-full h-full object-cover"/>
      <div class="bottom-40 left-40 bg-white p-20"  v-if="poi.externalLogo" :class="{'absolute': getBackgroundUrl}">
        <img :src="poi.externalLogo" class="h-112 max-w-278 object-contain"/>
      </div>
    </div>
    <div class="flex gap-16 grow w-full h-full justify-between items-end z-2 overflow-hidden">
      <WFScrollableArea class="w-full h-hull">
        <div class="flex flex-col gap-16 ">
          <div class="p-36">
            <div class="flex flex-col items-start gap-12">
              <WFTranslate v-if="poi.getFloor() && poi.getFloor().getName" k="floor" class="px-10 py-2 bg-active rounded-sm text-16 font-bold" :params="[poi.getFloor().getName(language)]"></WFTranslate>
              <label class="poi-name text-30 font-black" v-html="poi.getName(language)"></label>
            </div>
            <div class="flex w-full justify-between">
              <OpenHours v-if="poi.hasAttribute('opening_times')" :openingTimes="poi.getAttributeJSON('opening_times')"></OpenHours>
              <QR :poi="poi"></QR>
            </div>
          </div>
          <div class="p-36 flex gap-28 w-full justify-stretch pt-0" v-if="poi.getAttributeString('360')">
            <!--button class="th-btn th-btn-active basis-full" @click="onPOIClick"><WFIcon name="map" class="w-32 h-32"></WFIcon><WFTranslate k="show_path"></WFTranslate></button-->
            <button v-if="map360 == ''" class="th-btn th-btn-stroke basis-full" @click="on360Click"><WFIcon name="360" class="w-32 h-32"></WFIcon><WFTranslate k="open-360"></WFTranslate></button>
            <button v-if="map360 !== ''" class="th-btn th-btn-active basis-full" @click="on360Click"><WFIcon name="360" class="w-32 h-32"></WFIcon><WFTranslate k="close-360"></WFTranslate></button>
          </div>
          <div class="p-36 bg-white text-16">
            <div :class="{'read-less': !readMore}" v-if="poi.getDescription(language)" v-html="poi.getDescription(language)"></div>
            <div v-if="poi.getDescription(language) && poi.getDescription(language).length > 100">
              <button v-if="!readMore" type="button" class="font-bold focus:outline-none mt-8" @click="readMore = true"><WFTranslate k="read-more">Read more</WFTranslate></button>
              <button v-if="readMore" type="button" class="font-bold focus:outline-none mt-8"  @click="readMore = false"><WFTranslate k="read-less">Show less</WFTranslate></button>
            </div>
          </div>
          
          
        </div>
      </WFScrollableArea>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { WFTranslate } from "@3dwayfinder/wayfinder-vue-components";
import QR from "./QR.vue";
import OpenHours from "./OpenHours.vue";

export default {
  components: {
    WFTranslate,
    QR,
    OpenHours
  },
  computed: {
    ...mapState("wf", ["language", "reset"]),
    ...mapState(["map360"]),
    getBackgroundUrl () {
      if (this.poi && this.poi.getAttribute("bg")) {
        return this.poi.getAttributeString("bg");
      }

      return "";
    }
  },
  props: {
    poi: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      readMore: false,
    };
  },
  watch: {
    reset() {
      this.readMore = false;
    }
  },
  methods: {
    onPOIClick() {
      this.$store.dispatch("set360", "");
      this.$emit("onPOIClick", this.poi);
    },
    getFirstGroup(poi) {
      if (typeof poi === "object") {
        return (poi.getGroupNames().length) > 0 ? poi.getGroupNames()[0] : "";
      }

      return "";
    },
    showPath() {
      return () => {
        if (this.poi && this.poi.getNode() && this.poi.getNode().id) {
          this.$wayfinder.showPath(this.poi.getNode(), this.poi);
        }
      };
    },
    isImage () {
            if(this.poi) {
                if (this.poi.getIconUrl() != null && this.poi.getIconUrl().length > 0) return "image-logo";
            }
			
			return "image-none";
		},
    on360Click () {
      if (this.map360 == this.poi.getAttributeString("360")) {
        this.$store.dispatch("set360", "");
      }
      else {
        this.$store.dispatch("set360", this.poi.getAttributeString("360"));
      }
      
    }
  },
};
</script>

<style lang="postcss">
.poi {
  .poi-gradient {
    &::after {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      content: '';
      display: block;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
    }
    
  }

  .wf-poi {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 1.6rem;
  }

  .wf-poi-image {
    width: 5.6rem;
    height: 3.2rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .group-label {
    background-color: var(--th-neutral);
  }

  .poi-name {
    text-align: left;
  }

  .image-none {
      display: none;
  }

  .read-less {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }
}
</style>
